import Head from 'next/head';
import React from 'react';

interface IUseMetaFollowOptions {
  indexed?: boolean;
  noFollow?: boolean;
}

export default function useMetaIndexTag({
  indexed,
  noFollow,
}: IUseMetaFollowOptions) {
  return (
    <Head>
      <meta
        key="robots"
        name="robots"
        content={`${indexed ? 'index' : 'noindex'}, ${
          noFollow ? 'nofollow' : 'follow'
        }`}
      />
    </Head>
  );
}
